import { Button, Table, Input, Row, Col, Modal, Radio, message, Typography, Select, Card, Tag, Space} from "antd";
import { useEffect, useRef, useState, } from "react";
import Highlighter from 'react-highlight-words';
import api from "../../API";
import { DeleteOutlined, SearchOutlined, SyncOutlined } from "@ant-design/icons";

function GMF() {
    const user = JSON.parse(localStorage.getItem('user'));
    const [loading, setLoading] = useState({table: false, btn: false});
    const [dataSource, setDataSource] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [options, setOptions] = useState(null);
    const [selectedOAIndex, setselectedOAIndex] = useState(null);
    const originalZaloGroups = useRef([]);
    const originalOAAccounts = useRef([]);
  
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        width: 150,
        render: (text, record) =>
          searchText ? (
            <Typography.Link
              href={record.group_link}
              target="_blank"
              rel="noopener noreferrer">
                <Highlighter
                  highlightStyle={{
                    backgroundColor: '#ffc069',
                    padding: 0,
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={text ? text.toString() : ''}
                />
              </Typography.Link>
          ) : (
            <Typography.Link
              href={record.group_link}
              target="_blank"
              rel="noopener noreferrer">
                {text}
              </Typography.Link>
          )
      },
      {
        title: "Group ID",
        dataIndex: "group_id",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
      },
      {
        title: "OA Account",
        dataIndex: "accountName",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
      },
      {
        title: "Description",
        dataIndex: "group_description",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
      },
      {
        title: "Total Member",
        dataIndex: "total_member",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (status) => {
          if(!searchText) {
            if(status === "enabled")  return (<Tag color="#87d068">{status.toUpperCase()}</Tag>);
            return (<Tag color="#f50">{status.toUpperCase()}</Tag>)
          } 
          if(status === "enabled") return (
            <Tag color="#87d068">
              <Highlighter
                highlightStyle={{
                  backgroundColor: '#ffc069',
                  padding: 0,
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={status.toUpperCase()}
              />
            </Tag>)
          return (
          <Tag color="#87d068">
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={status.toUpperCase()}
            />
        </Tag>)
      }},
      {
        title: 'Action',
        key: 'action',
        width: 100,
        align: 'center',
        render: (_, record) => (
          <Button type="primary" danger 
                  icon={<DeleteOutlined/>}
                  onClick={() => {
                    Modal.confirm({
                      title: 'Confirm deletion',
                      content: 'Are you sure you want to delete this ZaloGoup?',
                      onOk() {handleRemoveRow(record.key)},
                      maskClosable: true
                    })
                  }}>
          </Button>),
      }
    ];
  
    useEffect(() => {
      setLoading({...loading, table: true});
      Promise.all([
        api.list_oaaccounts_by_user(user?.userId, user?.parentId,["id","accountName" , "OAId"]),
        api.list_all_zalogroups(user?.userId)])
      .then(([oaacounts, zalogroups]) => {
        originalZaloGroups.current = zalogroups.length? zalogroups.map(zalogroup => ({
          group_link: zalogroup.group_link,
          key: zalogroup.id,
          OAId: zalogroup.OAId,
          name: zalogroup.name,
          group_id: zalogroup.group_id,
          group_description: zalogroup.group_description,
          total_member: zalogroup.total_member,
          status: zalogroup.status,
          accountName: oaacounts.find(oaacount => oaacount.OAId === zalogroup.OAId)?.accountName,
        })) : [];
        originalOAAccounts.current = oaacounts;
        setOptions(oaacounts.map((oaacount, i) => ({
          value: i,
          label: oaacount.accountName
        })))
        setDataSource(originalZaloGroups.current); 
      })
      .catch(err => message.error(err.message))
      setLoading({...loading, table: false});
    }, []);

    function handleselectedOAIndex(OAIndex) {
      let newZaloGoups = originalZaloGroups.current;
      if(OAIndex || OAIndex === 0) newZaloGoups = newZaloGoups.filter(value => value.OAId === originalOAAccounts.current[OAIndex].OAId);
      if(searchText) newZaloGoups = newZaloGoups.filter((o) => Object.keys(o).slice(2).some((k) => o[k] && String(o[k])
        .toLowerCase()
        .includes(searchText.toLowerCase())));
      setLoading(true);
      setselectedOAIndex(OAIndex);
      setDataSource(newZaloGoups);
      setLoading(false);
    }
  
    function handleSearchInfo(e) {
      let newZaloGoups = originalZaloGroups.current;
      if(selectedOAIndex || selectedOAIndex === 0) newZaloGoups = newZaloGoups.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
      if(e.target.value) newZaloGoups = newZaloGoups.filter((o) => Object.keys(o).slice(3).some((k) => o[k] && String(o[k])
        .toLowerCase()
        .includes(e.target.value.toLowerCase())));
      setLoading(true);
      setSearchText(e.target.value);
      setDataSource(newZaloGoups);
      setLoading(false);
    }
  
    async function handleUpdateZaloGoups() {
      setLoading({...loading, btn: true});
      try {
        const res = await api.list_all_groups_on_zalo(user?.userId, user?.parentId, originalOAAccounts.current[selectedOAIndex]?.OAId);
        if(res) {
          const resZaloGroups = await api.list_all_zalogroups(user?.userId);
          let newZaloGroups = resZaloGroups.map(zalogroup => {
            const oaacountObj = originalOAAccounts.current.find(oaacount => oaacount.id === zalogroup.accountId);
            return{
            group_link: zalogroup.group_link,
            key: zalogroup.id,
            OAId: oaacountObj?.OAId,
            name: zalogroup.name,
            group_id: zalogroup.group_id,
            group_description: zalogroup.group_description,
            total_member: zalogroup.total_member,
            status: zalogroup.status,
            accountName: oaacountObj?.accountName
          }})
            originalZaloGroups.current = newZaloGroups.concat();
            if(selectedOAIndex  || selectedOAIndex === 0) newZaloGroups = newZaloGroups.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
            setDataSource(newZaloGroups);
        } else {
          message.error();
        }
      } catch (error) {
        message.error(error.message);
      } finally {
        setLoading({...loading, btn: false});
      }
    }
  
    async function handleRemoveRow(keyRemove) {
      try {
        setLoading({...loading, table: true});
        const responseRemove = await api.delete_zalogroup_byID(keyRemove);
        originalZaloGroups.current = originalZaloGroups.current.filter((value) => value.key !== keyRemove);
        let newZaloGoups = originalZaloGroups.current.concat();
        if(selectedOAIndex  || selectedOAIndex === 0) newZaloGoups = newZaloGoups.filter(value => value.OAId === originalOAAccounts.current[selectedOAIndex].OAId);
        setDataSource(newZaloGoups);
        message.success(responseRemove.message);
      } catch (error) {
        message.error(error.message)
      } 
      setLoading({...loading, table: false});
    }
  
    return (
      <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
          <Typography.Title level={5} style={{margin: 0}}>Zalo Group</Typography.Title>
        }
        loading={loading.table}
        extra={<Button type="primary" style={{padding:15}} loading={loading.btn} onClick={handleUpdateZaloGoups} icon={<SyncOutlined />}>Update Groups</Button>}
      >
        <Row gutter={[16,16]}  align="middle">
          <Col sm={24} xs={24} md={12}>
            <Select 
              style={{width:'100%'}}
              placeholder="Select OA Id"
              popupMatchSelectWidth={false}
              value={selectedOAIndex}
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              onChange={handleselectedOAIndex}
              options={options}
            />
          </Col>
          <Col sm={24} xs={24} md={12}>
            <Input 
                placeholder="Input search text"
                allowClear
                onChange={handleSearchInfo}
                suffix={<SearchOutlined />}/>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table  
              bordered
              scroll={{x: 1100}}
              columns= {columns} 
              style={{marginTop: 16, width: '100%'}} 
              dataSource={dataSource}
              loading={loading.table}
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: false, 
                pageSize: 10, 
                showTotal: () => `Total: ${dataSource.length} items`
              }}
              />
          </Col>
        </Row>
      </Card>
    )
}

export default GMF
